/**
 * Anchors for the Settings page's sections.
 *
 * Their own module, with no imports, because the account menu and the mobile
 * account sheet link at them: pulling an id out of a component module would
 * drag the whole Settings feature into the layout's import graph to fetch a
 * string — and, as a cycle through it proved, could hand them `undefined`.
 */
export const SECURITY_SECTION_ID = 'security';
